import { render, staticRenderFns } from "./ImageLoader.vue?vue&type=template&id=1f0587c0&scoped=true"
import script from "./ImageLoader.vue?vue&type=script&lang=ts"
export * from "./ImageLoader.vue?vue&type=script&lang=ts"
import style0 from "./ImageLoader.vue?vue&type=style&index=0&id=1f0587c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f0587c0",
  null
  
)

export default component.exports